// frontend/src/services/publicRoutes.js
//
// Routes rendered without a session. A missing token there is not an expired
// session: `api.js` must not toast "Sessão expirada" nor wipe storage.

const PUBLIC_ROUTE_PREFIXES = ["/login", "/signup", "/forgetpsw"];

export const isPublicRoute = (pathname) => {
  const path = String(pathname || "").split("?")[0].replace(/\/+$/, "") || "/";

  return PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
};
